import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 580"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "m118.581 525.69 6.917 46.444-45.455 6.917-7.905-46.442zm72.132-10.868 7.905 45.454-47.43 7.906-5.93-46.443zm72.13-11.86 6.916 47.432-45.454 5.93-7.905-45.456zm-155.136-49.404L114.624 500l-46.443 6.918-6.917-46.444zm72.132-10.87 6.918 46.444-45.455 6.915-7.904-46.442zm72.134-10.869 6.917 45.455-46.443 7.905-6.916-46.443zM20.751 62.253 77.075 431.82l-19.763 2.965L0 65.218zm21.737-31.621 61.265 397.234-19.763 2.964L22.725 34.585zM84.984 0l64.23 420.95-19.764 1.975L65.22 3.952zm31.615 33.595 59.288 383.4-18.775 1.976L97.824 36.56zm52.375 35.576 52.37 339.92-19.762 3.954-52.372-340.91zm24.703-16.798 54.347 352.768-18.773 2.964-55.337-352.767zM493.083 468.38 500 514.822l-203.557 31.621-7.905-47.431zm-11.854-72.133 7.905 45.454-204.545 31.621-5.928-45.455z"
    }, null, -1)
  ]))]))
}
export default { render: render }